import type { ConversationTask } from "@/services/api/guardiansv2/types";
import type { ScopeLabelCache } from "../audits/useScopeLabelCache";
import { ConversationBubbles } from "./ConversationBubbles";
import { GuardianEvalBubble } from "./GuardianEvalBubble";
import { TaskConversationDivider } from "./TaskConversationDivider";

export interface TaskConversationBlockProps {
  row: ConversationTask;
  missionId?: string | null;
  scopeLabels: ScopeLabelCache;
}

export function TaskConversationBlock({
  row,
  missionId,
  scopeLabels,
}: TaskConversationBlockProps) {
  const { task, thread, screening } = row;

  return (
    <section className="space-y-1.5" data-testid={`conversation-task-${task.id}`}>
      <TaskConversationDivider task={task} missionId={missionId} scopeLabels={scopeLabels} />
      <div className="rounded-xl bg-slate-900/40 px-3 py-2">
        <ConversationBubbles thread={thread} />
      </div>
      <GuardianEvalBubble screening={screening} scopeLabels={scopeLabels} />
    </section>
  );
}
